<template lang="html">
  <div class="container-fluid">
         <div class="col-md-8 order-md-1">
          <h4 class="mb-3">Contact information</h4>
<form v-on:submit.prevent="addcontact">
  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="firstname">First Name</label>
      <input type="text" class="form-control" id="firstname" placeholder="First Name" v-model="firstname">
    </div>
    <div class="form-group col-md-6">
      <label for="lastname">Last Name</label>
      <input type="text" class="form-control" id="lastname" placeholder="Last Name" v-model="lastname">
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="dob">Date of Birth</label>
      <input type="date" class="form-control" id="dob" v-model="dob">
    </div>

    <div class="form-group col-md-6">
      <label for="inlineFormCustomSelectPref">Gender</label>
        <select class="custom-select" id="inlineFormCustomSelectPref" v-model="gender">
            <option selected>Choose...</option>
          <option value="Female">Female</option>
          <option value="Male">Male</option>
        </select>
    </div>

  </div>

  <button type="submit" class="btn btn-primary">Add Contact</button>
</form>
            </div>
    <div>
<table class="table table-hover table-sm col-md-8" ref="contacts" :data="contacts">
  <thead>
    <div class = "row" slot="header">
      <h4 scope="col">
       Contacts 
      </h4>
    </div>
    <tr>
      <th class="text-center" scope="col">Full Name</th>
      <th class="text-center" scope="col">Date of Birth</th>
      <th class="text-center" scope="col">Gender</th>
    </tr>
  </thead>
  <tbody>
        <tr v-for="contact in contacts" v-bind:key="contact.id" >
          <td class="text-center" scope="row">
           <router-link class="nav-link" v-bind:to="{name: 'edit-contact', params: {contact_id: contact.fullnamecode}}">{{contact.fullname}}</router-link> 
          </td>
          <td class="text-center">
            {{contact.dob}}
          </td>
            <td class="text-center">
            {{contact.gender}}
          </td>
        </tr>
  </tbody>
  </table>
  </div>
  </div>
</template>

<script>
import db from './firebaseInit'
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/firestore');

export default {
  name: 'contactinfo',
  data () {
    return {
      contacts: [],
      firstname: null,
      lastname: null,
      gender: null,
      dob: null
    }
  },
  created: function(){
    this.loaddata()
 
  
  },
  mounted: function(){
   
  },
  methods: {
  loaddata: function(){
    var userId

  var user = firebase.auth().currentUser;
   if (user != null) {
      userId = user.uid;
      } 

    
  db.collection('users').doc(userId).collection('contacts').get().then
  (querySnapshot => {

    querySnapshot.forEach(doc => {
      //console.log(doc.data());
  const data = {
        'id' : doc.data().id,
        'fullnamecode' : doc.data().fullnamecode,
        'fullname' : doc.data().firstname + ' ' + doc.data().lastname,
        'gender' : doc.data().gender,
        'dob' : doc.data().dob
      }
      
       this.contacts.push(data)

    }) 
  }
  )
  
    },
    addcontact: function(){
  var user = firebase.auth().currentUser;
  var userId
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('contacts').add({
    firstname: this.firstname,
    lastname: this.lastname,
    gender: this.gender,
    dob: this.dob,
    fullnamecode: this.firstname + '_' + this.lastname
  }).then(ref => {
  const data = {
        'id' : ref.id,
        'fullname' : this.firstname + ' ' + this.lastname,
        'fullnamecode' : this.firstname + '_' + this.lastname,
        'gender' : this.gender,
        'dob' : this.dob
      }
  this.contacts.push(data)  
  this.firstname = ''
  this.lastname = ''
  this.gender = ''
  this.dob = ''
})
}

  },
  computed: {
  }

}
</script>